"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemperaturePanel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TemperatureBox = require("./_TemperatureBox");
var _TemperatureContainer = require("./_TemperatureContainer");
var _TemperaturePanelModule = _interopRequireDefault(require("../../styles/components/TemperaturePanel.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** @todo Refactor component with avoiding magic numbers, styles and 'div' tag. */
const TemperaturePanel = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    thingPDIDDeviceList = []
  } = _ref;
  const {
    length: deviceLength
  } = thingPDIDDeviceList;
  if (!deviceLength) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-column ".concat(_TemperaturePanelModule.default.wrap_temperature_box, " ").concat(deviceLength > 3 ? 'flex-end' : 'flex-center')
  }, deviceLength > 3 ? /*#__PURE__*/_react.default.createElement(_TemperatureContainer.TemperatureContainer, {
    thingPDIDDeviceList: thingPDIDDeviceList
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: _TemperaturePanelModule.default.wrapper
  }, thingPDIDDeviceList === null || thingPDIDDeviceList === void 0 ? void 0 : thingPDIDDeviceList.map(thingPDIDDevice => /*#__PURE__*/_react.default.createElement(_TemperatureBox.TemperatureBox, {
    key: thingPDIDDevice,
    alone: deviceLength < 2
    // Temporary solution
    ,
    moreThanTwo: deviceLength > 2,
    thingPDIDDevice: thingPDIDDevice
  }))));
});
exports.TemperaturePanel = TemperaturePanel;
TemperaturePanel.propTypes = {
  thingPDIDDeviceList: _propTypes.default.arrayOf(_propTypes.default.string)
};